export default __webpack_public_path__ + "static/capsule-control-alert-system-495feab38efab7f81e504fb0f3fcf608.png";